import { ErrorOutlineRounded } from '@mui/icons-material'
import { InformationCard } from 'feature/informationCard'
import { MainLayout } from 'layouts'

export function PageInDevelop() {
  return (
    <MainLayout>
      <div className='container'>
        <InformationCard
          title='Страница находится в разработке'
          subtitle='Совсем скоро она заработает'
          Icon={<ErrorOutlineRounded fontSize='large' color='primary' />}
          link='/'
          linkText='На главную'
        />
      </div>
    </MainLayout>
  )
}
